import React from 'react';
import { useSelector } from 'react-redux';
// noinspection ES6CheckImport
import { Redirect } from 'react-router-dom';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import TabsContainer from '../../molecules/TabsContainer';
import UserShowcaseTab from '../../organisms/UserShowcaseTab';

function UserShowcase() {
  const userID = useSelector((state) => state.auth.uid);

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />
          <TabsContainer
            icon_code="fas fa-cash-register"
            title="NA VITRINE"
            tabs={[{ title: ' ', url: '/usuario/vitrine' }]}>
            <UserShowcaseTab tabId="user_showcase_tab" userId={userID} />
          </TabsContainer>
        </S.UserSoldContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserShowcase;
